import { render, staticRenderFns } from "./sos_settings_modal.vue?vue&type=template&id=0dec5cdc&scoped=true&"
import script from "./sos_settings_modal.vue?vue&type=script&lang=js&"
export * from "./sos_settings_modal.vue?vue&type=script&lang=js&"
import style0 from "./sos_settings_modal.vue?vue&type=style&index=0&id=0dec5cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dec5cdc",
  null
  
)

export default component.exports